const pagesIdpEn = {
  settings: {
    authenticationMethod: {
      comingSoonBadge: 'Coming soon',
      description: 'Configure authentication methods for this organization.',
      title: 'Authentication method'
    },
    navigation: {
      authenticationMethod: 'Authentication method',
      label: 'Settings',
      password: 'Password',
      session: 'Session rules',
      sso: 'SSO'
    },
    sso: {
      description: 'Provides SSO to external SaaS (DRESS CODE = IdP).',
      title: 'SSO — Connected SaaS'
    }
  },
  tabs: {
    accessRules: 'Access rules',
    alerts: 'Alerts',
    authPolicies: 'Authentication policies',
    operationActivity: 'Operation activity',
    overview: 'Overview',
    settings: 'Settings'
  },
  title: 'Identity Policy'
};
export default pagesIdpEn;